// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__WRBBd","footer":"style_footer__19E2Y","footer__mobile":"style_footer__mobile__r5sEk"};